/* Admin Login Component */

import React from "react";
import { MDBBtn, MDBRow, MDBCol } from "mdbreact";
import "./Reset.css";
import "./AdminLogin.css";

export default function AdminLogin(props) {

    return (
        <div className="adminLoginContainer">
            {props.requestPending ? (
                <div className="admin-loading-container">
                    <div className="spinner-border mb-3 admin-loading-spinner" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <h4 className="admin-loading-title">Loading...</h4>
                    <p className="admin-loading-text">Please wait while we load available login options.</p>
                </div>
            ) : props.isOktaConfigured || props.isOffice365Configured ? (
                <>
                    <div className="admin-buttons-container">
                        {props.isOktaConfigured && (
                            <MDBBtn 
                                onClick={props.oktaLoginHandler} 
                                type="button" 
                                color="danger"
                                className="admin-sso-btn"
                            >
                                Login with Okta
                            </MDBBtn>
                        )}
                        {props.isOffice365Configured && (
                            <MDBBtn 
                                onClick={props.office365LoginHandler} 
                                type="button" 
                                color="danger"
                                className="admin-sso-btn"
                            >
                                Login with Office365
                            </MDBBtn>
                        )}
                    </div>
                </>
            ) : (
                <div className="admin-no-config-container">
                    <p>No admin login methods are currently configured.</p>
                    <p>Please login using your standard login page.</p>
                </div>
            )}
        </div>
    );
}
